<template>
  <div id="publishVideoBox">
    <div class="publishPreviewNav">
      <img src="../../../../img/logo.png" alt="" />
      <span class="publishNavTitle">大百科</span>
    </div>
    <div class="videoContentBox">
      <h2 class="videoPageTitle">
        {{ articleTitle }}
      </h2>
      
      <div id="adBox" v-if="adverInfo.type == 10">
        <a :href="adverInfo.link"  target="_blank"><img :src="adverInfo.path" :alt="adverInfo.linkContent"></a>
        <!-- <span @click="closeAdver()">
          <i class="el-icon-close"></i>
          关闭广告
        </span> -->
      </div>
      <div class="videoMainBox">
        <el-row class="topBox">
          <el-col :xs="24" :lg="5" class="time">
            <i class="el-icon-timer" style="margin-right: 5px"></i>
            <span>添加时间：{{ videoInfo.addTime }}</span>
          </el-col>
          <el-col :xs="24" :lg="4" class="hits">
            <i class="el-icon-view" style="margin-right: 5px"></i>
            <span>点击量：{{ hits }}</span>
          </el-col>
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="15"
            :xl="15"
            class="fontButton"
          >
            <span class="pointer enlarge" @click="fontLarge()"></span>
            <span class="pointer narrow" @click="fontNarrow()"></span>
          </el-col>
        </el-row>
        <el-row class="videoBox">
          <el-col :xs="24" :md="16" :lg="16" class="leftBox">
            <video
              controls
              :src="videoUrl"
              width="100%"
              height="100%"
              style="background-color: #000"
              @ended="handleVideoEnded"
              :poster="videoPoster"
            ></video>
            <div id="getContent" hidden></div>
            <div class="finishInfo" hidden>
              <p><a href="videoInfo.link">查看更多</a></p>
            </div>
          </el-col>
          <el-col :xs="24" :md="8" :lg="8" class="publishViewRightBox">
            <nav class="videoNav"><span>介绍</span></nav>
            <div class="videoContent">
              <div class="contentTop">
                <p class="zjr">
                  <span class="info name-info">主讲人</span>{{ videoInfo.zjr }}
                </p>
                <p class="keyWords">
                  <span class="info keyWords-info">关键词</span>
                  <span style="color: #335a98">
                    {{ videoInfo.word }} 
                    <span v-if="adverInfo.linkContent" style="color: rgb(51, 90, 152)">、</span>
                    <a v-if="adverInfo.linkContent" :href="adverInfo.link" target="_blank" style="color: rgb(51, 90, 152);text-decoration: underline;">{{ adverInfo.linkContent }}</a> 
                  </span>
                </p>
              </div>
              <div class="contentBottom">
                <div class="zjjs">专家介绍</div>
                <div
                  class="zjrjjContent fontsize"
                  v-html="videoInfo.zjrjj"
                ></div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="fenji">
          <div class="fenjiTitle">
            分集列表<span class="total"
              >（共<span>{{ listData.length }}</span
              >集）</span
            >
          </div>
          <ul class="fenjiList">
            <li class="fl" v-for="(item, index) in listData" :key="index">
              <a
                v-if="item.id != currentId"
                :href="'/videoDetail?id=' + item.id"
                >{{ index + 1 }}</a
              >
              <a
                v-if="item.id == currentId"
                :href="'/videoDetail?id=' + item.id"
                class="activeFenji"
                >{{ index + 1 }}</a
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- 广告部分 -->
      <div id="adBox" v-if="adFlag">
        <img src="https://ai.bkzx.cn/zyk/resource/upload/image/banner.jpg" alt="">
        <!-- <span @click="adFlag = false">
          <i class="el-icon-close"></i>
          关闭广告
        </span> -->
      </div>
       <!-- 正式广告展示部分 -->
      <div id="adBox" v-if="adverInfo.type == 30">
        <a :href="adverInfo.link" target="_blank"><img :src="adverInfo.path" :alt="adverInfo.linkContent"></a>
        <!-- <span @click="closeAdver()">
          <i class="el-icon-close"></i>
          关闭广告
        </span> -->
      </div>
      <div id="adSide" v-if="adverInfo.type == 20">
        <a :href="adverInfo.link" target="_blank"><img :src="adverInfo.path" :alt="adverInfo.linkContent"></a>
        <!-- <span @click="closeAdver()">
          <i class="el-icon-close"></i>
          关闭广告
        </span> -->
      </div>
    </div>

    <div class="publishFooter">
      <div class="footerContent">
        <p>版权所有 © 北京百科在线文化传媒有限公司</p>
        <p>京ICP备12000488号-2</p>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      articleTitle: "",
      videoUrl: "",
      videoInfo: "",
      videoPoster: "",
      currentId: "",
      listData: [],
      hits: "",
      pageTitle: "",
      adFlag:false,
      adverInfo:{},
    };
  },
  mounted() {
    window.addEventListener("scroll", this.updateScrollDistance);

    let that = this;
    $.ajax({
      type: "GET",
      dataType: "json",
      url: "/zyk/webapi/free/word/detail",
      data: { wordId: this.$route.query.id },
      contentType: "application/json;charset=utf-8",
      success: function (response) {
        if (response.code == 200) {
          var data = response.obj;

          // 判断是否显示广告内容
          var adArray = [16920557,16920440,16919686]
          that.adFlag = adArray.includes(data.id)      
          
          
          if(data.adverInfo){
            that.adverInfo = data.adverInfo
          }

          that.articleTitle = data.name;
          that.videoUrl = data.httpPath;
          that.hits = data.hits;
          document.title = data.name + "-大百科";
          $("#getContent").html(data.content);
          let resourceid = $("#getContent video").attr("resourceid");
          that.videoUrl = data.resourceInfos[resourceid].httpPath;
          that.videoInfo = data.resourceInfos[resourceid].resourceInfoExtend;
          that.videoPoster = data.resourceInfos[resourceid].logoPath;
          that.currentId = data.id;

          $.ajax({
            type: "GET",
            dataType: "json",
            url: "/zyk/webapi/free/word/list",
            data: { subjectId: data.subjectId },
            contentType: "application/json;charset=utf-8",
            success: function (responseData) {
              if (response.code == 200) {
                that.listData = responseData.obj;
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
                window.location.href = "/blank";
              }
            },
            error: function (data) {
              console.log(data);
              window.location.href = "/blank";
            },
          });
        } else {
          that.$message({
            message: response.msg,
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
          window.location.href = "/blank";
        }
      },
      error: function () {
        window.location.href = "/blank";
      },
    });
  },
  methods: {
    handleVideoEnded() {
      console.log("视频播放完毕");
      $(".finishInfo").show();
    },
    // 字体放大s
    fontLarge() {
      $(".fontsize").each(function () {
        var cssfontSize, csslineHeight;
        if ($(this).hasClass("adv-content")) {
          cssfontSize = $(this).find("p").css("font-size");
          csslineHeight = $(this).find("p").css("line-height");
        } else {
          cssfontSize = $(this).css("font-size");
          csslineHeight = $(this).css("line-height");
        }

        var unit = cssfontSize.slice(-2);
        var fontSize = parseFloat(cssfontSize);
        var lineHeight = parseFloat(csslineHeight);
        if (fontSize > 22) return false;
        fontSize = fontSize + 2;
        lineHeight = lineHeight + 2;
        if ($(this).hasClass("adv-content")) {
          $(this)
            .find("*")
            .css("font-size", fontSize + unit);
          $(this)
            .find("*")
            .css("line-height", lineHeight + unit);
        } else {
          $(this).css("font-size", fontSize + unit);
          $(this).css("line-height", lineHeight + unit);
        }
      });
    },
    // 字体缩小
    fontNarrow() {
      $(".fontsize").each(function () {
        var cssfontSize, csslineHeight;
        if ($(this).hasClass("adv-content")) {
          cssfontSize = $(this).find("p").css("font-size");
          csslineHeight = $(this).find("p").css("line-height");
          if (!cssfontSize) {
            cssfontSize = 16;
            csslineHeight = 28;
          }
        } else {
          cssfontSize = $(this).css("font-size");
          csslineHeight = $(this).css("line-height");
        }

        var unit = cssfontSize.slice(-2);
        var fontSize = parseFloat(cssfontSize);
        var lineHeight = parseFloat(csslineHeight);
        if (fontSize < 14) return false;
        fontSize = fontSize - 2;
        lineHeight = lineHeight - 2;
        if ($(this).hasClass("adv-content")) {
          $(this)
            .find("*")
            .css("font-size", fontSize + unit);
          $(this)
            .find("*")
            .css("line-height", lineHeight + unit);
        } else {
          $(this).css("font-size", fontSize + unit);
          $(this).css("line-height", lineHeight + unit);
        }
      });
    },
    
    closeAdver(){
      $("#adBox").hide()
      $("#adSide").hide()
    }
  },
};
</script>

<style>
#publishVideoBox {
  border-left: 5px solid #cd2022;
  background: #f6f6f6;
  height: 100%;
}

#publishVideoBox .videoContentBox {
  width: 70vw;
  padding: 90px 0 50px;
  margin: 0 auto;
}

#publishVideoBox .videoContentBox .videoPageTitle {
  color: #000000;
  font-size: 40px;
  line-height: 52px;
  font-weight: bold;
  margin-bottom: 20px;
}

#publishVideoBox .videoContentBox .videoMainBox {
  border: 1px solid #eee;
}

#publishVideoBox .videoContentBox .videoMainBox .topBox {
  background-color: #eeeeee;
  border-bottom: 2px solid #cd2022;
  padding: 13px 15px;
  color: #909090;
  font-size: 12px;
  line-height: 24px;
}

#publishVideoBox .videoContentBox .videoBox {
  height: 60vh;
}

/* #publishVideoBox .videoContentBox .videoBox::after {
  content: "";
  display: inline-block;
  clear: both;
} */

#publishVideoBox .videoContentBox .videoBox .leftBox {
  /* width: 65%; */
  height: 100%;
  /* float: left; */
  position: relative;
}

#publishVideoBox .videoContentBox .videoBox .leftBox .finishInfo {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  text-align: center;
}
#publishVideoBox .videoContentBox .videoBox .leftBox .finishInfo p {
  display: inline-block;
  position: absolute;
  vertical-align: middle;
  top: 50%; /* 向上偏移50% */
  left: 50%; /* 向左偏移50% */
  transform: translate(-50%, -50%);
}

#publishVideoBox .videoContentBox .videoBox .publishViewRightBox {
  /* width: 35%; */
  /* height: 60vh; */
  float: left;
  margin-top: 0%;
  max-height: 100%;
  overflow: visible;
  overflow-x: hidden;
}

#publishVideoBox
  .videoContentBox
  .videoBox
  .publishViewRightBox::-webkit-scrollbar {
  width: 10px; /* 修改宽度 */
}

#publishVideoBox .videoContentBox .videoBox .publishViewRightBox .videoNav {
  background-color: #e7e7e7;
  padding: 10px 5px 7px;
}
#publishVideoBox
  .videoContentBox
  .videoBox
  .publishViewRightBox
  .videoNav
  span {
  background-color: #fff;
  padding: 8px 20px;
  border-radius: 5px 5px 0 0;
  font-size: 12px;
}

#publishVideoBox .videoContentBox .videoBox .publishViewRightBox .videoContent {
  padding: 35px 30px;
  font-size: 14px;
  color: #555555;
  line-height: 24px;
}

#publishVideoBox .videoContentBox .videoMainBox .fenji .fenjiTitle {
  background-color: #dbdbdb;
  font-size: 16px;
  color: #333;
  line-height: 60px;
  padding: 0px 25px;
}

#publishVideoBox .videoContentBox .videoMainBox .fenji ul {
  background-color: #e7e7e7;
  padding: 23px 25px;
  overflow: auto;
  border-bottom: 2px solid #cd2022;
}

#publishVideoBox .videoContentBox .videoMainBox .fenji ul::after {
  content: "";
  display: inline-block;
  clear: both;
}

#publishVideoBox .videoContentBox .videoMainBox .fenji ul li a {
  margin-bottom: 5px;
  margin-right: 6px;
  display: inline-block;
  color: #000000;
  border: 1px solid #dadada;
  border-radius: 4px;
  background-color: #ffffff;
  width: 50px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

#publishVideoBox .videoContentBox .videoMainBox .fenji ul li .activeFenji {
  background-color: #cd2022;
  border: 1px solid #cd2022;
  color: #fff;
}

#publishVideoBox .videoContentBox .videoMainBox .fenji .fenjiTitle .total {
  color: #666;
}

#publishVideoBox .videoContent .contentTop {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 10px;
}

#publishVideoBox .videoContent .contentTop .info {
  border-radius: 12px;
  display: inline-block;
  color: #fff;
  padding: 0px 7px;
  margin-right: 10px;
  margin-bottom: 10px;
}

#publishVideoBox .videoContent .contentTop .name-info {
  background-color: #cd2022;
}

#publishVideoBox .videoContent .contentTop .keyWords-info {
  background-color: #a1a1a1;
}

#publishVideoBox .videoContent .contentBottom .zjjs {
  color: #999999;
  line-height: 26px;
  font-size: 12px;
  margin-top: 20px;
  margin-bottom: 5px;
}

#publishVideoBox .fontButton {
  text-align: right;
}

#publishVideoBox .fontButton .enlarge {
  background: url(../../../../img/icon9.png) no-repeat center center;
  display: inline-block;
  width: 18px;
  height: 23px;
  margin: 0px 10px;
}

#publishVideoBox .fontButton .narrow {
  background: url(../../../../img/icon10.png) no-repeat center center;
  display: inline-block;
  width: 18px;
  height: 23px;
  margin: 0px 10px;
}

#publishVideoBox .publishPreviewNav {
  box-shadow: 0px 0px 24px 0px #0000001c;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 999;
  padding: 15px 30px;
}

#publishVideoBox .publishPreviewNav .publishNavTitle {
  font-size: 24px;
  font-weight: bolder;
  position: absolute;
  top: 50%;
  transform: translateY(-60%);
  margin-left: 10px;
}

#publishVideoBox .publishFooter {
  width: 100%;
  background-color: #2f2f2f;
  padding: 50px 0;
}

#publishVideoBox .publishFooter .footerContent {
  text-align: center;
  margin: 0 auto;
  color: rgba(255, 255, 255, 0.38);
  font-size: 14px;
}

#publishVideoBox .publishFooter .footerContent p + p {
  margin-top: 10px;
}

#publishVideoBox #adBox{
  width: 500px;
  margin: 50px auto 0;
  position: relative;
  color: #fff;
  font-size: 14px;
}
#publishVideoBox #adBox img{
  width: 100%;
}
#publishVideoBox #adBox span{
  position: absolute;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 3px 5px;
  cursor: pointer;
}

@media screen and (max-width: 1200px) {
  #publishVideoBox .videoContentBox {
    width: 95vw;
  }

  #publishVideoBox
    .videoContentBox
    .videoBox
    .publishViewRightBox
    .videoContent {
    padding: 10px 15px;
  }
}

@media screen and (max-width: 768px) {
  #publishVideoBox .videoContentBox {
    width: 90vw;
    padding: 70px 0 0;
  }
  #publishVideoBox .videoContentBox .videoPageTitle {
    font-size: 20px;
    margin-bottom: 0;
  }
  /* #publishVideoBox .videoContentBox .videoBox {
    height: 28.5vh;
  } */

  #publishVideoBox .videoContentBox .videoBox {
    height: auto;
    width: 100%;
  }

  #publishVideoBox
    .videoContentBox
    .videoBox
    .publishViewRightBox
    .videoContent {
    padding: 10px 0;
  }

  #publishVideoBox .videoContent .contentBottom .zjjs {
    margin-top: 5px;
  }

  #publishVideoBox .videoContent .contentTop .info {
    font-size: 12px;
  }

  #publishVideoBox #adBox{
    width: 100%;
  }
}
</style>